import gql from 'graphql-tag';

export default gql`
    mutation ConfigureInventory($input: ConfigureInventoryInput) {
        configureInventory(input: $input) {
            errors
        }
    }
`;
